"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var graph_1 = require("../../utils/graph");
var LegendPlotPoint = function (_a) {
    var color = _a.color, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-legend-plot-point", className), style: { backgroundColor: (0, graph_1.getPlotColor)(color) } }));
};
exports.default = LegendPlotPoint;
